import type { IView } from '@barba/core';
import { IdleQueue } from 'idlize/IdleQueue.mjs';
import pageAnimations from '../animations/pages/product/init-page-animations';
import productHandlers from '../inits/pages/product/product-handlers';
import productSwiper from '../inits/pages/product/product-swipers';
import headerCartHandlers from '@/inits/components/header/header-cart-handlers';
import customReviewsSlider from '@/inits/components/common/custom-reviews-slider';
import customResearchesSlider from '@/inits/components/common/custom-researches-slider';
import productDocumentsModule from '@/inits/pages/product/product-documents';
import productReviewPopupsModule from '@/inits/components/common/reviews-slider-popups';
import productChangeTheme from '@/inits/pages/product/product-change-theme';

const beforeEnterQueue = new IdleQueue();

export default {
    namespace: 'product-page',

    beforeEnter({ next }) {
        productHandlers.init();
        headerCartHandlers.initForPage();
        customReviewsSlider.init();
        customResearchesSlider.init();
        productDocumentsModule.init();
        productReviewPopupsModule.init();
        productSwiper.init();

        beforeEnterQueue.pushTask(() => {
            pageAnimations.init();
        });
    },

    afterEnter() {
        const productVideoElement = document.querySelector<HTMLVideoElement>('.js-video-popup-element');

        if (productVideoElement) {
            productVideoElement.pause();
            productVideoElement.currentTime = 0;
        }
    },

    beforeLeave({ current }) {
        productHandlers.destroy();
        headerCartHandlers.destroyForPage();
        customReviewsSlider.destroy();
        customResearchesSlider.destroy();
        productDocumentsModule.destroy();
        productReviewPopupsModule.destroy();
        productSwiper.destroy();
    },
} as IView;
